import { waitForSpacesBetaOptIns } from '@/spaces/use/use-spaces-beta-access';

const BETA_OPT_IN_WAITERS = {
    spaces: waitForSpacesBetaOptIns,
};

export async function waitForRouteBetaOptIns (route) {
    await BETA_OPT_IN_WAITERS[route.meta.betaId]?.();
}
